import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setDeleteDocumentError, setLoading } from "../../repository/slice";

function* deleteDocumentHardWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, `/api/admin/document/delete/${payload.id}/hard`);
        if (isError) {
            yield put(setDeleteDocumentError(message));
        } else {
            yield put(setDeleteDocumentError(null));
        }
    } catch (error) {
        console.error("deleteDocumentHardWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteDocumentHardWatcher() {
    yield takeLatest("@saga/DELETE_DOCUMENT_HARD", deleteDocumentHardWorker);
};
